import "../assets/styles/blogList.scss"
import BlogPosts from "../components/BlogPosts";
import Footer from "../components/Footer";
import Header from "../components/Header";
import React, { useRef, useEffect  } from 'react';

function BlogList() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on mount

  }, []);
  return (
       <div className="blog-container">
               <Header/>
    <div className="main-container">

       <div className="blog-banner">
        <img src={require('../assets/images/blog-banner.png')} alt="blog banner"/>
        <div className="texts">
            <h3>وطن اکسپرس، سرویس جدید حمل‌ونقل وطن</h3>
            <p>حمل‌ونقل وطن، در راستای ارتقا کیفی خدمات خود به مشتریان، اقدام به راه‌اندازی خدمتی جدید برای ارسال ویژه بار با عنوان وطن اکسپرس نموده است. این سرویس که از مزایای خاصی از جمله حمل سریع‌تر و ایمن‌تر برخوردار است، به صورت درب‌-به-درب بوده و نیاز مشتری را از حمل بار تا باربری بی‌نیاز می‌کند.</p>
        </div>
       </div>

       <div className="blog-features">
        <div className="feature-item">
            <img src={require('../assets/images/blog-feature-1.png')} alt="blog feature"/>
            <h5>آشنایی با سرویس رهگیری بار</h5>
            <p>این یک متن آزمایشی است. از متن‌های آزمایشی برای پیش‌نمایش محصولات دیجیتال استفاده می‌شود...</p>
        </div>

        <div className="feature-item">
            <img src={require('../assets/images/blog-feature-1.png')} alt="blog feature"/>
            <h5>آشنایی با سرویس رهگیری بار</h5>
            <p>این یک متن آزمایشی است. از متن‌های آزمایشی برای پیش‌نمایش محصولات دیجیتال استفاده می‌شود...</p>
        </div>

        <div className="feature-item">
            <img src={require('../assets/images/blog-feature-1.png')} alt="blog feature"/>
            <h5>آشنایی با سرویس رهگیری بار</h5>
            <p>این یک متن آزمایشی است. از متن‌های آزمایشی برای پیش‌نمایش محصولات دیجیتال استفاده می‌شود...</p>
        </div>
       </div>

       <div className="blog-posts-container">
        <h2>تازه‌ترین‌های وبلاگ وطن</h2>

         <BlogPosts />

       </div>
    </div>

    <Footer/>
    </div>
  );
}

export default BlogList;


// Fake Change to Test Git